const TOKEN = 'token';

export const setToken = (token: string) => {
	localStorage.setItem(TOKEN, token);
}

export const getToken = () : string | null => {
	return localStorage.getItem(TOKEN);
}
